import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ModalComponent } from './modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) { }

  open(data: any) {
    const initialState = { item: data };
    this.bsModalRef = this.modalService.show(ModalComponent, { initialState });
  }
}
